import { Link } from "react-router-dom";
import { Ghost } from "lucide-react";

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-4 py-20 text-center">
      <Ghost className="h-12 w-12 text-muted" />
      <h2 className="font-display text-2xl font-semibold text-text">
        Page not found
      </h2>
      <p className="text-muted">That route doesn't exist yet.</p>
      <Link
        to="/"
        className="rounded-lg bg-primary px-4 py-2 font-medium text-primary-fg"
      >
        Back home
      </Link>
    </div>
  );
}
